import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-info-banner',
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss'],
})
export class InfoBannerComponent {
  @Input() text: string;
  @Input() type: string;
  @Input() noWidth: boolean;
  @Input() actionType: string;
  @Input() buttonText: string;
  @Input() isGiftDistribution?: boolean;
  @Input() isPendingDeposit?: boolean;
  @Output() buttonClicked = new EventEmitter<void>();

  ionIcon = {
    warning: 'warning-sharp',
    info: 'information-circle',
    danger: 'alert-circle',
    success: 'happy',
    gift: 'gift',
    sync: 'sync-outline',
  };

  constructor() {}

  onButtonClick(): void {
    this.buttonClicked.emit();
  }
}
